import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { first, Observable, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';

import { selectAuthTokens } from '@modules/authorization/store/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    return this.store.select(selectAuthTokens).pipe(
      first(),
      switchMap((auth) => {
        const authReq = auth?.accessToken
          ? req.clone({ setHeaders: { Authorization: 'Bearer ' + auth?.accessToken } })
          : req;
        return next.handle(authReq);
      })
    );
  }
}
